import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItem {
  title: string;
  content: string;
  cta?: string;
  ctaHref?: string;
}
interface UseCaseAccordionProps {
  items: AccordionItem[];
}
export const UseCaseAccordion: React.FC<UseCaseAccordionProps> = ({
  items
}) => {
  const [activeIndex, setActiveIndex] = useState(-1);
  const toggleAccordion = (index: number) => {
    setActiveIndex(activeIndex === index ? -1 : index);
  };
  return <div className="border-t border-lightgray" data-id="element-151" data-mp="2muhlqg6bm2b8">
      {items.map((item, index) => <div key={index} className="border-b border-lightgray" data-id="element-152" data-mp="2mwajf5yyhc73" data-mpi={index}>
          <button className="w-full text-left py-4 md:py-5 pr-4 flex justify-between items-start group" onClick={() => toggleAccordion(index)} data-id="element-153" data-mp="284s7bj97w1t0">
            <div className="flex-1" data-id="element-154" data-mp="30tz7emobkzgd">
              <h3 className="font-poppins font-normal text-lg md:text-xl text-black group-hover:text-lime transition-colors" data-id="element-155" data-mp="30sxsu883hutw">
                {item.title}
              </h3>
            </div>
            <ChevronDownIcon className={`transform transition-all duration-300 flex-shrink-0 mt-1 text-black group-hover:text-lime ${activeIndex === index ? 'rotate-180' : 'rotate-0'}`} size={20} data-id="element-156" data-mp="5fhkfjh3l0u2" />
          </button>
          <div className={`overflow-hidden transition-all duration-300 ${activeIndex === index ? 'max-h-96 opacity-100 pb-4 md:pb-5' : 'max-h-0 opacity-0'}`} data-id="element-157" data-mp="9g1daaun1iae">
            <p className="font-inter text-base leading-relaxed text-black mb-6" data-id="element-158" data-mp="j6mm0r410371">
              {item.content}
            </p>
            {item.cta && item.ctaHref && <a href={item.ctaHref} className="font-inter font-semibold inline-flex items-center text-black hover:text-lime transition-colors" data-id="element-159" data-mp="x41ey5thmt3r">
                {item.cta}
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-1" data-id="element-160" data-mp="2uvx14zr0q7cp">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-161" data-mp="12v5i6ga1i335" />
                </svg>
              </a>}
          </div>
        </div>)}
    </div>;
};